import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */
(function () {

  var hasOwn = {}.hasOwnProperty;

  function classNames() {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(null, arg);

        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  if ( module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

var wrapWithRequired = function wrapWithRequired(validator, isRequired) {
  if (isRequired) {
    return {
      isRequired: validator
    };
  }

  return validator;
};

var validClassNamesObjectPrefix = function validClassNamesObjectPrefix(prefix, isRequired) {
  return wrapWithRequired(function (props, propName, componentName) {
    var obj = props == null ? void 0 : props[propName];

    if (!obj) {
      if (isRequired) {
        return new Error("\"" + propName + "\" is required for \"" + componentName + "\".");
      }

      return null;
    }

    var keys = Object.keys(obj);

    if (keys.length === 0) {
      return new Error("Invalid prop \"" + propName + "\" supplied to \"" + componentName + "\".");
    }

    var prefixRegex;

    if (Array.isArray(prefix)) {
      prefixRegex = prefix.map(function (regExp) {
        return new RegExp("^" + regExp);
      });
    } else {
      prefixRegex = [new RegExp("^" + prefix)];
    }

    var _loop = function _loop(i) {
      var key = keys[i];
      var propFullNameWithKey = propName + "." + key;

      if (!prefixRegex.some(function (regex) {
        return regex.test(key);
      })) {
        return {
          v: new Error("Invalid key \"" + propFullNameWithKey + "\" supplied to \"" + componentName + "\". Key is expected to match \"" + prefix + "\".")
        };
      }
    };

    for (var i = 0; i < keys.length; i++) {
      var _ret = _loop(i);

      if (typeof _ret === "object") return _ret.v;
    }

    return null;
  }, isRequired);
};

var _excluded = ["id", "className", "style", "classNames", "as", "size", "weight", "align", "uppercase", "children"];
var HeadingAsElement = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  p: "p",
  span: "span",
  div: "div"
};

var Heading = function Heading(_ref) {
  var _cx;

  var id = _ref.id,
      className = _ref.className,
      style = _ref.style,
      classNames = _ref.classNames,
      as = _ref.as,
      size = _ref.size,
      weight = _ref.weight,
      align = _ref.align,
      uppercase = _ref.uppercase,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Tag = "" + as;
  var classes = classnames((_cx = {}, _cx[classNames == null ? void 0 : classNames["heading--" + size]] = size && (classNames == null ? void 0 : classNames["heading--" + size]), _cx[classNames == null ? void 0 : classNames["heading--" + weight]] = weight && (classNames == null ? void 0 : classNames["heading--" + weight]), _cx[classNames == null ? void 0 : classNames["heading--" + align]] = align && (classNames == null ? void 0 : classNames["heading--" + align]), _cx[classNames == null ? void 0 : classNames["heading--uppercase"]] = uppercase && (classNames == null ? void 0 : classNames["heading--uppercase"]), _cx[className] = className, _cx));
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classes,
    id: id
  }, props, {
    style: style
  }), children);
};

Heading.displayName = "Heading";
Heading.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,

  /**
   * Requires an object with keys that are prefixed by `heading--` mapped to class names.
   *
   * Size, and weight props will output `heading--{value}`
   *
   * For alignment, it requires `heading--left`, `heading--center`, `heading--right`
   *
   * Uppercase requires `heading--uppercase`
   *
   *
   * `object`
   *
   * @type {object}
   *
   */
  classNames: validClassNamesObjectPrefix("heading--", true).isRequired,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  as: PropTypes.oneOf(Object.keys(HeadingAsElement)),
  size: PropTypes.string,
  weight: PropTypes.string,
  align: PropTypes.oneOf(["left", "center", "right"]),
  uppercase: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Heading.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined,
  as: HeadingAsElement.h1,
  size: undefined,
  weight: undefined,
  align: "left",
  uppercase: false,
  children: undefined
};

export default Heading;
export { Heading, HeadingAsElement };
//# sourceMappingURL=index.js.map
